import uuidv1 from 'uuid/v1';

// HEAD DATA
export const headData = {
  title: 'Ankur|Developer|Test Engineer', 
  lang: 'en', 
  description:" Hello!!, my name is Ankur Singh, I am a Developer & SDET with a passion for exploration and continual learning.",
  author: "@AnkurSingh",
  image:'https://www.uschamberfoundation.org/sites/default/files/styles/detail_image800w/public/code%2C%20coder%2C%20coding%2C%20coffee%2C%20computer%2C%20copy%2C%20hands%2C%20js%2C%20keyboard%2C%20laptop%2C%20note%2C%20php%2C%20programmer%2C%20programming%2C%20writing%2C%20work%2C%20office.jpg?itok=Ba0HeGFQ',
  twitterUsername:"@Monki_baat",
  siteUrl: "https://ankursinghpp.netlify.com"
};

// HERO DATA
export const heroData = {
  title: "Hi there, I’m",
  name: 'Ankur Singh. ',
  subtitle: '',
  cta: '',
};

// ABOUT DATA
export const aboutData = {
  img: 'profile.jpg',
  paragraphOne: 'Ankur Singh is an aspiring software engineer with more than 4 years of experience and proven successful track record of delivering technology-based products and services.',
  paragraphTwo: 'My current focus is building 🤖 Automation Solution ⚗️ for testing 📱 and 🕸️ App.',
  paragraphThree: ' I love using technology in creative contexts. ⛹️',
  resume: '/resume.pdf', // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [
  {
    id: uuidv1(),
    img: 'project.jpg',
    title: 'React gatsby personal site ',
    info: 'Personal site showcasing my blog, projects and online resume.',
    info2: 'Tech Stack :- Gatsby, React, GraphQL, Nodejs, Netify.',
    url: '',
    repo: '', // if no repo, the button will not show up
  },
  {
    id: uuidv1(),
    img: 'Project_3.jpg',
    title: 'BackRods Travel Blog',
    info: "It's a responsive travel blog app that displays the latest upcoming travel sightseeing, built using ReactJS and gatsby for  management.The graphql API is used to fetch data from contentful (CMS). Can search for travel blog based on place and time. Can view full details including day wise event of each travel by clicking on 'EXPLOR TOUR' button.",
    info2: 'Tech Stack :- Gatsby, React, GraphQL, Nodejs, Netify, contentful.',
    url: 'https://feedyoursoul.netlify.com/',
    repo: 'https://github.com/ankur1233/reactProject', // if no repo, the button will not show up
  },
  {
    id: uuidv1(),
    img: 'project_4.jpg',
    title: 'Automation Framework',
    info: 'Build automated test framework around core applications with a maximum code coverage',
    info2: 'Tech Stack :- Java, Selenium-WebDriver, testNG, jenkins, alureReport.',
    url: 'https://youtu.be/WUmlhrGfZyk',
    repo: '', // if no repo, the button will not show up
  },
];

// CONTACT DATA
export const contactData = {
  cta: "Let's Build Something Together 🧰 ⛏️ 🔧 ",
  btn: '',
  email: 'ankursingh.creative@gmail.com',
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: uuidv1(),
      name: 'twitter',
      url: 'https://twitter.com/Monki_baat',
    },

    {
      id: uuidv1(),
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/ankur-singh-link',
    },
    {
      id: uuidv1(),
      name: 'github',
      url: 'https://github.com/ankur1233',
    },
  ],
};


